/**
 * Put plain text on the clipboard. The async clipboard API first; where the browser
 * refuses it (an embedded view, an older phone, no permission), a selection copy on a
 * throwaway textarea. False when neither worked, for the caller to say so.
 *
 * @module web/screens/copyPlainText
 */
export async function copyPlainText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    /* refused or missing: the selection copy below */
  }
  const area = document.createElement("textarea");
  area.value = text;
  area.setAttribute("readonly", "");
  area.style.position = "fixed";
  area.style.opacity = "0";
  document.body.append(area);
  try {
    area.select();
    return document.execCommand("copy");
  } catch {
    return false;
  } finally {
    area.remove();
  }
}
